import { CheckCircle2, Inbox, Siren, UserRound } from "lucide-react";
import type { InboxQueue } from "@/types/conversation/conversation";

const QUEUES: { value: InboxQueue; label: string; Icon: typeof Inbox }[] = [
  { value: "all", label: "All", Icon: Inbox },
  { value: "attention", label: "Needs attention", Icon: Siren },
  { value: "mine", label: "Assigned to me", Icon: UserRound },
  { value: "handled", label: "Handled", Icon: CheckCircle2 },
];

export const INBOX_QUEUE_EMPTY: Record<Exclude<InboxQueue, "all">, { title: string; description: string }> = {
  attention: {
    title: "Nothing needs you right now",
    description: "Calls and emails your Listener genie flags as needing a reply land here until someone handles them.",
  },
  mine: {
    title: "Nothing assigned to you",
    description: "Take a call or email from Needs attention and it waits here until you mark it handled.",
  },
  handled: {
    title: "Nothing handled yet",
    description: "Calls and emails your team replied to or marked handled show up here.",
  },
};

interface InboxQueueTabsProps {
  value: InboxQueue;
  onChange: (queue: InboxQueue) => void;
}

/** The central inbox's queues over a Listener genie's calls and forwarded email. */
export function InboxQueueTabs({ value, onChange }: InboxQueueTabsProps) {
  return (
    <div className="inline-flex p-[2px] rounded-xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]">
      <div className="flex rounded-[10px] bg-white" role="tablist" aria-label="Inbox queues">
        {QUEUES.map(({ value: queue, label, Icon }, idx) => {
          const active = value === queue;
          return (
            <button
              key={queue}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(queue)}
              className={`min-h-[44px] sm:min-h-0 px-3.5 py-2 flex items-center gap-2 whitespace-nowrap text-sm transition-colors ${
                active ? "bg-gray-100 text-gray-900 font-semibold" : "text-gray-600 hover:bg-gray-50"
              } ${idx === 0 ? "rounded-l-[10px]" : ""} ${idx === QUEUES.length - 1 ? "rounded-r-[10px]" : ""}`}
            >
              <Icon className={`w-4 h-4 ${active ? "text-genie-primary" : ""}`} />
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
